module.exports = __webpack_public_path__ + "img/eMove-background.ae45f7ea.png";